export function getCustomerFromHostname(): string {
    const { hostname } = window.location;

    if (hostname === 'localhost') {
        return 'localhost';
    }

    const parts = hostname.split('.');

    if (parts.length >= 3 && parts[1] === 'positioning' && parts[2] === 'get-e') {
        const customer = parts[0];

        if (customer) {
            return customer;
        }
    }

    throw new Error(`Unable to extract customer from hostname: ${hostname}`);
}

export function getApiUrl(): string {
    const customer = getCustomerFromHostname();

    if (customer === 'localhost') {
        return 'http://localhost:8083';
    }

    return `https://api.${customer}.positioning.get-e.com`;
}
